import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=1a615fda&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a615fda')) {
      api.createRecord('1a615fda', component.options)
    } else {
      api.reload('1a615fda', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=1a615fda&", function () {
      api.rerender('1a615fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TPEForm/components/Question/Question.vue"
export default component.exports